/* eslint-disable */
export default {
    inserted: function(el) {
        // Append course id and zip code to provided form action
        el.onsubmit = function(e){
            var courseIdEl = el.querySelector('#courseid');
            var courseZipCodeEl = el.querySelector('#zipcode');
            var originalFormAction = el.getAttribute('action');
            var newFormAction = originalFormAction;

            if(courseIdEl && courseIdEl.value) {
                newFormAction += '&courseid=' + courseIdEl.value;
                if(courseZipCodeEl && courseZipCodeEl.value) {
                    newFormAction += '&zipcode=' + courseZipCodeEl.value;
                }
            }

           el.action = encodeURI(newFormAction);
        };
    }
  };



// WEBPACK FOOTER //
// ./src/app/directives/course-search-form.js